<template>
  <div>
    <el-table
      :data="data"
      stripe
      :dynamicOperationName="dynamicOperationName"
      @selection-change="handleSelectionChange"
      :row-key="getRowKeys"
      ref="multipleTable"
      :height="height"
      :max-height="height"
      style="width: 100%">
      <el-table-column
        type="selection"
        label="序号"
        width="50"
        :reserve-selection="true"
        v-show="showCheck">
      </el-table-column>
      <!-- <el-table-column
        type="selection"
        width="50"
        v-if="showCheck">
      </el-table-column> -->
      <el-table-column v-for="item in head"
                       :key="item.head"
                       :show-overflow-tooltip="show"
                       :prop="item.props"
                       :label="item.label"
                       :min-width="item.width"
                       v-if="(item.props=='studyPk') ? false : true">
      </el-table-column>
      <el-table-column v-if="dynamicOperationName==='entryPage'"
                       :width="operationWidth"
                       type="index"
                       label="">
        <template slot-scope="scope">
          <div v-if='scope.row.state==1' class="beginning">进行中</div>
          <div v-else-if='scope.row.state==0' class="nobegin">未进行</div>
        </template>
      </el-table-column>
      <el-table-column
        type="index"
        label="操作"
        :width="operationWidth">
        <template slot-scope="scope">
          <el-button v-if="dynamicOperationName === 'entryPage'" @click="_operation(scope.row, item.class,scope.$index)"
                     v-for="(item,index) in operation"
                     type="text"
                     :key="item.class"
                     :class="scope.row.state==1?item.class:item.class2" class="iconfont" size="big" :title="item.title">
          </el-button>
          <el-button v-if="dynamicOperationName === ''" @click="_operation(scope.row, item.class,scope.$index)"
                     v-for="item in operation"
                     type="text"
                     :key="item.class"
                     :class="item.class" class="iconfont" size="big" ><span class="hover_title" :title="item.name">{{item.name}}</span>
          </el-button>
          <el-button v-if="dynamicOperationName === 'operate'" @click="_operation(scope.row, item.class,scope.$index)"
                     v-for="(item,index) in operation"
                     type="text"
                     :key="item.class"
                     :class="(index==0?(scope.row.reportState=='3' ? item.class:item.class2):(index==3 ? (scope.row.readFilmFlag !='1' ? item.class : item.class2):item.class)) " class="iconfont" size="big" :title="item.title">{{item.operation}}
            <!--item.readFilmFlag ==0 ? item.class : item.class2-->
          </el-button>
          <el-button v-if="dynamicOperationName === 'courseWare'&& scope.row.creator !== UserId" @click="_operation(scope.row, item.class,scope.$index)"
                     v-for="item in operationPrivate"
                     type="text"
                     :key="item.class"
                     :class="item.class" class="iconfont Private" size="big" ><span class="hover_title" :title="item.name">{{item.name}}</span>
          </el-button>
          <el-button v-if="dynamicOperationName === 'courseWare'&& scope.row.creator === UserId" @click="_operation(scope.row, item.class,scope.$index)"
                     v-for="item in operationOpen"
                     type="text"
                     :key="item.class"
                     :class="item.class" class="iconfont" size="big" ><span class="hover_title" :title="item.name">{{item.name}}</span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script type="text/ecmascript-6">
  import {getLocalStorage, saveLocalStorage} from '@/common/js/localStorage'
  import * as _ from '@/common/js/config'
  import http from '@/api/http'
  export default {
    props: {
      showCheck:{
        type: Boolean,
        default: false,
      },
      data: {
        type: Array,
        default: function () {
          return []
        }
      },
      head: {
        type: Array,
        default: () => []
      },
      operation: {
        type: Array,
        default: () => []
      },
      operationWidth: {
        type: String,
        default: '100'
      },
      dynamicOperationName: {
        type: String,
        default: ''
      },
      height: {
        type: Number,
        default: 260
      },
      width:{
        type: String,
        default: ''
      },
      ReportList: {
        type: Array,
        default: function () {
          return []
        }
      },
      studyList: {
        type: Array,
        default: function () {
          return []
        }
      },
      checkNumber: {
        type: String,
        default: ''
      }
    },
    computed: {},
    watch: {
      $route (n, o) {
        this._getH()
      },
      data (c, o) {
        this.$nextTick(() => {
          this.data.forEach(row => {
            for (let item of this.aOldResult) {
              if (item['hospitalId'] === row['hospitalId'] && item['studyPk'] === row['studyPk'] && item['hospitalId'] != 'undefined' && item['studyPk'] != 'undefined') {
                this.$refs.multipleTable.toggleRowSelection(row, true)
              }
            }
          });
        })
      },
      aOldResult(c, o) {
        this.$nextTick(() => {
          this.data.forEach(row => {
            for (let item of c) {
              if (item['hospitalId'] === row['hospitalId'] && item['studyPk'] === row['studyPk'] && item['hospitalId'] != 'undefined' && item['studyPk'] != 'undefined') {
                this.$refs.multipleTable.toggleRowSelection(row, true)
              }
            }
          });
        })
      },
      studyList(c, o) {
        this.aOldResult = c
      }
    },
    created() {
      this.getUserInfo(),
      this.aOldResult = this.studyList
    },
    mounted() {
      setTimeout(() => {
        this._getH()
      }, 50)
      window.addEventListener('resize', () => {
        setTimeout(() => {
          this._getH()
        }, 50)
      })
    },
    methods: {
      handleSelectionChange(val){
        // 表格选中事件
        this.aOldResult = val
      },
      getList(){
        this.$emit('selection',this.aOldResult);
      },
      getUserInfo() {
        http.post('/getUserInfo.json').then(res => {
          if (res.data.code === _.ERR_OK) {
            this.UserId = res.data.model.userId
          } else {
          }
        }).catch(err => {
        })
      },
      _operation(row, operation,index) {
        let payload = Object.assign(row, {
          operation,
          index
        })
        this.$emit('_operation', payload)
      },
      _getH() {
        let innerH = document.getElementsByClassName('left')[0].clientHeight
        let crumbs = document.getElementsByClassName('crumbs')[0].clientHeight
        let search
        if(document.getElementsByClassName('search')[0]===undefined){
          search = 56
        } else {
          search = document.getElementsByClassName('search')[0].clientHeight +40
        }
        if(this.showCheck) {
          this.height = innerH - crumbs - search - 125
        } else {
          this.height = innerH - crumbs - search - 102
        }

      }
    },
    data() {
      return {
        aOldResult: [],
        result: [],
        height: 210,
        show: true,
        isDel: false,
        applyToMeOperation: [],
        multipleSelection:[],
        select_orderId:[],
        UserId: '',
        getRowKeys(row) {
          return row.studyPk;
        },
        operationOpen: [
          {
            name: '查看',
            operation: '',
            class: 'icon-chakan'
          },
          {
            name: '修改',
            operation: '',
            class: 'icon-bianji'
          },
          {
            name: '删除',
            operation: '',
            class: 'icon-shanchu'
          }
        ],
        operationPrivate: [
          {
            name: '查看',
            operation: '',
            class: 'icon-chakan'
          },
          {
            name: '修改',
            operation: '',
            class: 'icon-bianji hui'
          },
          {
            name: '删除',
            operation: '',
            class: 'icon-shanchu hui'
          }
        ]
      }
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable.styl'
  .hover_title
    display: inline-block
    width: 19px
    height: 19px
    opacity: 0
    margin-left: -19px
</style>



// WEBPACK FOOTER //
// teachManageTable.vue?5b413077